import { Drill, drillCategories } from "@/data/drills";
import { TacticalDiagram } from "./TacticalDiagram";

interface DrillPreviewCardProps {
  drill: Drill;
}

export function DrillPreviewCard({ drill }: DrillPreviewCardProps) {
  const category = drillCategories.find((c) => c.id === drill.category);

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/5">
      <div className="aspect-[4/3] bg-muted/50 relative overflow-hidden">
        <TacticalDiagram data={drill.diagram} />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-1 rounded text-xs font-medium text-white ${category?.color || 'bg-primary'}`}>
            {category?.label}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-display text-sm text-foreground line-clamp-1 mb-1">
          {drill.title}
        </h3>
        <p className="text-xs text-muted-foreground line-clamp-2">
          {drill.description}
        </p>
      </div>
    </div>
  );
}
